import { Popover, Tooltip } from '@mui/material'
import React, { useEffect, useRef } from 'react'
import { SubMenuIconWrapper, SubMenuWrapper, TextLink } from '../Styles/Styles'
import { FaFireIcon } from '../../../Images/icon'
import useClickOutside from '../../../../hooks/useClickOutside/useClickOutside'

const permission = JSON.parse(localStorage.getItem("permissions")) || [];

const hotdealAccess = permission.find((o) => o.slug === "hotdeal_event");
const hotdealVehicleAccess = permission.find((o) => o.slug === "hotdeal_vehicle_action");



const HotdealsSubMenu = () => {

    const hasReadPermissionForHotdeals = hotdealAccess?.permissions?.find((o) => o.slug === "read")
    const hasReadPermissionForHotdealVehicles = hotdealVehicleAccess?.permissions?.find((o) => o.slug === "read")

    const popoverRef = useRef(null);
    const isOutsideClicked = useClickOutside(popoverRef);

    const [anchorEl, setAnchorEl] = React.useState(null);

    useEffect(() => {
        if (isOutsideClicked) {
            handleClose();
        }
    }, [isOutsideClicked])

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    if (!hasReadPermissionForHotdeals &&
        !hasReadPermissionForHotdealVehicles
    ) {
        return null
    }

    return (
        <>
            <Tooltip title='Hotdeals' placement="right">
                <SubMenuIconWrapper
                    onClick={handleClick}
                >
                    <FaFireIcon />
                </SubMenuIconWrapper>
            </Tooltip>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                ref={popoverRef}
            >
                <SubMenuWrapper>
                    {hasReadPermissionForHotdeals &&
                        <>
                            <TextLink
                                to="/hotdeal-events"
                                onClick={handleClose}
                            >
                                Hotdeal Events
                            </TextLink>
                            <TextLink
                                to="/hotdeals"
                                onClick={handleClose}
                            >
                                Hotdeals
                            </TextLink>
                        </>
                    }
                    {hasReadPermissionForHotdealVehicles &&
                        <>
                            <TextLink
                                to="/cancel-hotdeals-reservation-request"
                                onClick={handleClose}
                            >
                                Cancel Hotdeal Reservation
                            </TextLink>
                            <TextLink
                                to="/vehicle-reservation-history"
                                onClick={handleClose}
                            >
                                Vehicle Reservation History
                            </TextLink>
                        </>

                    }
                </SubMenuWrapper>
            </Popover>
        </>
    )
}

export default HotdealsSubMenu